// extracted by mini-css-extract-plugin
export default {"header__notifications":"HeaderNotification_header__notifications__lepC0"};